// extracted by mini-css-extract-plugin
export default {"sections":"Biometrics_sections__qxwPC api-enabler-styles_overviewSections__SHdCd zb-container","card":"Biometrics_card__oH0ke zb-card"};